/**
 * Whether documents a company's ERP pushes to /api/v1/lao/documents go to the
 * MoF gateway queue straight away, or are stored as "held" until someone sends
 * them from the documents table.
 *
 *   Settings/laoEtax = {
 *     apiAutoIssue: { '<companyID>': true | false },
 *     defaultApiAutoIssue: true | false,
 *   }
 *
 * Resolution: the company's own entry, then defaultApiAutoIssue, then ON.
 * MIRRORS firebase/functions/src/libs/libLaoEnv.js resolveLaoApiAutoIssue —
 * change both together. The backend throws on a non-boolean value rather than
 * guessing; this viewer reports it as such instead.
 *
 * Written ONLY by the callSetLaoEtaxAutoIssue function (engineers, from the
 * ตั้งค่า Lao eTax page). A request's own `autoIssue` overrides it per push.
 */

/**
 * @param {object} data       Settings/laoEtax document body ({} when absent)
 * @param {string} companyID
 * @returns {{ enabled: boolean|null, source: string }}  null = invalid value
 */
export function apiAutoIssueFor(data, companyID) {
  const d = data || {};
  const cid = (companyID || "").toString().trim();
  const map = d.apiAutoIssue;
  if (cid && map && typeof map === "object" && Object.prototype.hasOwnProperty.call(map, cid)) {
    const v = map[cid];
    return {
      enabled: typeof v === "boolean" ? v : null,
      source: 'apiAutoIssue["' + cid + '"]',
    };
  }
  if (d.defaultApiAutoIssue !== null && typeof d.defaultApiAutoIssue !== "undefined") {
    const v = d.defaultApiAutoIssue;
    return {
      enabled: typeof v === "boolean" ? v : null,
      source: "defaultApiAutoIssue",
    };
  }
  return { enabled: true, source: "ค่าเริ่มต้น (เปิด)" };
}
